<template>
  <div class="home">
    <ProductSummaryCostList :scroll="corY" ref="refreshList" />
  </div>
</template>

<script>
import ProductSummaryCostList from '@/components/product/ProductSummaryCostList.vue'

export default {
  name: 'ProductSummaryCost',
  components: {
    ProductSummaryCostList
  },
  data () {
    return {
      corX: 0,
      corY: 0,
      listView: true,
      formView: false,
      productCategory: [],
      vendors: [],
      product: {
        id: null,
        product_no: null,
        product_name: null,
        qty: null,
        uom_id: null,
        amount: null
      }
    }
  },
  methods: {
    onClickEditFromList: function (value) {
      var x = window.pageXOffset
      var y = window.pageYOffset
      this.corX = x
      this.corY = y
      window.scrollTo(0, 0)
      this.listView = false
      this.formView = true
      this.product = value
    },
    onClickNewFromList: function () {
      var x = window.pageXOffset
      var y = window.pageYOffset
      this.corX = x
      this.corY = y
      window.scrollTo(0, 0)
      this.listView = false
      this.formView = true
      this.product = {
        id: null,
        product_no: null,
        product_name: null,
        qty: null,
        uom_id: null,
        amount: null
      }
    },
    async onBackChild () {
      window.scrollTo(this.corX, this.corY)
      this.listView = true
      this.formView = false
      this.product = {
        id: null,
        product_no: null,
        product_name: null,
        qty: null,
        uom_id: null,
        amount: null
      }
      this.$refs.refreshList.refreshProduct()
    }
  },
  mounted () {
    this.$store.dispatch('getProductUomList')
    this.$store.dispatch('getProductCategoryList')
    this.$store.dispatch('getProductTypeList')
    this.$store.dispatch('getVendorList')
    this.$store.dispatch('getPriceListGroup')
    this.$store.dispatch('getRowTable')
    this.$store.dispatch('getBranchList')
    this.$store.dispatch('getWarehouseList')
    this.$store.dispatch('getCompanyList')
  }
}
</script>
